var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54297 4.95825H13.3109C13.5088 4.95826 13.7045 4.99974 13.8854 5.08002C14.0664 5.1603 14.2284 5.27759 14.3612 5.42435C14.494 5.5711 14.5946 5.74405 14.6565 5.93205C14.7184 6.12005 14.7402 6.31894 14.7205 6.51588L14.2955 10.7659C14.2605 11.1154 14.0969 11.4396 13.8364 11.6753C13.576 11.911 13.2372 12.0416 12.8859 12.0416H6.1213C5.79368 12.0417 5.47614 11.9283 5.22274 11.7206C4.96935 11.5129 4.79577 11.2239 4.73155 10.9026L3.54297 4.95825Z",
    stroke: "#F8F8F8",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54297 4.95833L2.96922 2.66121C2.93085 2.50803 2.84239 2.37207 2.71791 2.27492C2.59342 2.17777 2.44004 2.125 2.28214 2.125H1.41797M5.66797 14.875H7.08463M11.3346 14.875H12.7513",
    stroke: "#F8F8F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCart);
export default __webpack_public_path__ + "static/media/icon-add-cart.8451486d20af3592795cc03c20564dba.svg";
export { ForwardRef as ReactComponent };